<template>

  <div  ref="envCard" @click="click" :class="cardClass+' '+fullStyle" :style="'width:'+(docWidth+10)+'px; height:'+(docHeight+100)+'px'">
    <div class="drag cardTitle" v-if="document">{{document.name}}</div>
     <DocScanner v-if="document && !fullSize"  :allowScan="false" :mapVis="mapVis" @showMap="showMap" :active="fullSize" :document="document" :width="docWidth" :height="docHeight" :style="style" ></DocScanner>
   
    <slot></slot>
    <div style="position:absolute;width:100%;height:100%;">
         <MapPanel v-if="mapEdit && fullSize" @hideMap="hideMap" ref="mapPanel" class="floatingMap" :width="docWidth" style="height:100%; width:100%;" @activateMap="isActive=!isActive"></MapPanel>
  
  <LeafletMap v-if="!mapEdit && fullSize" ref="mapPanel" :width="docWidth" :mapHeightOffset="80" :style="'height:'+(docHeight+25)+'px; width:100%;'" @activateMap="isActive=!isActive" :hideSearchArea="true"></LeafletMap>
 
   <div v-if="!fullSize" @click="viewDoc" class="basicBtn" style="width:100px;">Show Map</div>
   <div v-else @click="viewDoc" class="closeDoc basicBtn">Close Map</div>
   </div>
  
  </div>
</template>

<script>



import DocScanner from "@/components/DocScanner.vue";

import ConnectedElement from "@/components/ConnectedElement.vue"
import MapPanel from "@/components/MapPanel.vue";
import LeafletMap from "@/components/LeafletMap.vue";
export default {
  components:{
   LeafletMap,
   DocScanner,
   MapPanel,
   ConnectedElement
 
  },
  props: {
    cardClass:{default:"expertCard"},
    card:null,
    index:null,
    resizeCallback:null,
    selected:{default:false}
  },
  data() {
    return {
      fullSize:false,
       mapVis:false,
       isActive:true,
       style:"opacity:.9;border:none;text-transform: uppercase;margin-auto"
  
    };
  },
  computed: {
     knownDocs(){
      return this.$store.getters.getKnownDocs
    },
    viewedDocs(){
      return this.$store.getters.getViewedDocs
    },
    mapInfo(){
      return this.$store.getters.getCurrentMap
    },
    mapEdit(){
      return this.$store.getters.getMapEdit
    },
    windowHeight(){
      return window.innerHeight-200
    },
    windowWidth(){
      return window.innerWidth-100
    },
    docRatio(){
      if(this.docSize){
        return this.docSize.width/this.docSize.height
      }
      return  9/16
    },
    docScale(){
      let sh=this.windowHeight/this.docSize.height
      let sw=this.windowWidth/this.docSize.width
      return Math.min(sh,sw)
    },
    docSize(){
      if(this.document["image-size"]){
        let docSize=this.document["image-size"].split(",")
        if(docSize.length==2){
          return {width:parseInt(docSize[0]),height:parseInt(docSize[1])}
        }
      }
      return {width:800,height:600}
    },
    docWidth(){
      
      if(this.fullSize){
        return this.docSize.width*this.docScale
      }else{
        return 203
      }
    },
    docHeight(){
      if(this.fullSize){
       return Math.floor(this.docWidth/this.docRatio)
      }else{
        return 204
      }
    },
    fullStyle(){
      if(this.fullSize){
        return " fullSize"
      }else{
        return ""
      }
    },
   document(){
     console.log("ENV CARD", this.card.id)
     if(this.$store.getters.getMap(this.card.id)){
       return this.$store.getters.getMap(this.card.id)
     }
    this.$store.dispatch('loadMap',this.card.id)
   }
  },
  methods: {
    resizeMap(){
      this.$refs.mapPanel.doResize()
    },
    showMap(){
      this.mapVis=true;
      //this.readLocations()
    },
    hideMap(){
      this.mapVis=false;
    },
    viewDoc(){
     
      if(!this.fullSize){
        this.readLocations()
      }
      this.fullSize=!this.fullSize

    },
    click(){
      this.$emit('click',this.index)
    },
    readLocations(){
       console.log("XXXXX +info",this.knownDocs,this.mapInfo)
      for(var l in this.knownDocs){
        
        if(this.knownDocs[l].indexOf("Loc-")>-1  && !this.viewedDocs.includes(this.knownDocs[l])){
          this.viewedDocs.push(this.knownDocs[l])
        }
      }
    
    }
  },
  watch:{
    fullSize(val){
      this.$set(this.card,'width',this.docWidth)
      this.$set(this.card,'height',this.docHeight)
      if(val){
          let docRight=this.$refs.envCard.getBoundingClientRect().left+this.docWidth
          if(docRight>this.windowWidth){
            this.$emit("moveCardLeft",docRight-this.windowWidth+50)
          }
           let docTop=this.$refs.envCard.getBoundingClientRect().top+this.docHeight
          if(docTop>this.windowHeight){
            this.$emit("moveCardTop",docTop-this.windowHeight-70)
          }
        this.$store.commit('setCurrentMap',this.card.id)
      }else{
         this.$emit("resetCardPos")
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/sass/variables.scss";
.documentCard {
  text-align: center;
  min-height: 240px!important;
  top:0px;
  left:8px;
  border: solid 3px #0bf;
  background-color: $glow-bg;
  box-shadow: inset 0px 0px 20px 0px;
  color: #0bf;
  line-height: 30px;
  margin:10px;
  
  position:relative;
  
}

  .drag{
    cursor:move;
    cursor:grab;
  }
  .drag:active {
     cursor:move;
    cursor: grabbing;
  }
.floatingMap{
  width:700px;
  border: solid 3px $glow-text-colour-selected;
}

.closeDoc{
  text-align: center;
}
</style>